module.exports = __webpack_public_path__ + "static/img/4.0821d21.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/6/sp/4.png
// module id = Y1iu
// module chunks = 0